<template>
  <div>
    <v-app
      id="vitec"
    >
      <div id="loading" v-if="isLoading">
        <div id="error" v-if="errored">{{errorText}}</div>
        <div v-if="!errored">
          {{loadingText}}
          <p class="mt-3">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </p>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Digital Protokoll",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: "no",
      amp: true
    }
  },
  data() {
    return {
      isLoading: true,
      errored: false,
      errorText: "",
      loadingText: "Henter info om protokoll fra Vitec"
    }
  },
  mounted() {
      const data = {
          protocolType: this.$route.params.protocolType,
          vitecInstallation: this.$route.params.provider,
          estateId: this.$route.params.estateId
      }
      this.axios
      .post(
        process.env.VUE_APP_PROTOCOL_API +
          "vitec/create_protocol/", data
      )
      .then(response => {
          let protocolId = response.data.data.id
          this.$router.push({ path: '/' + protocolId })
      }).catch(error => {
        //this.errorText = error;
        console.log(error);
        this.errored = true;
        this.errorText = "Beklager, men kunne ikke hente informasjon om protokoll fra Vitec!"
      });
  }
}

</script>

<style src="@/assets/styles/main.css">
</style>